import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PriorityLevelActionResponse, PriorityLevelPageResponse, PriorityLevelRequest, PriorityLevelResponse } from "../model/priority-level.model";
import { RequirementApiResponse } from "../model/requirement.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffPriorityLevelsService {
  private readonly priorityLevelsUrl: string;

  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    this.priorityLevelsUrl = `${basePath.replace(/\/$/, "")}/api/v1/priority-levels`;
  }

  list(limit = 10, offset = 0): Observable<RequirementApiResponse<PriorityLevelPageResponse>> {
    const params = new HttpParams().set("limit", limit).set("offset", offset);
    return this.http.get<RequirementApiResponse<PriorityLevelPageResponse>>(this.priorityLevelsUrl, { params });
  }

  get(id: number): Observable<RequirementApiResponse<PriorityLevelResponse>> {
    return this.http.get<RequirementApiResponse<PriorityLevelResponse>>(`${this.priorityLevelsUrl}/${id}`);
  }

  create(request: PriorityLevelRequest): Observable<RequirementApiResponse<PriorityLevelResponse>> {
    return this.http.post<RequirementApiResponse<PriorityLevelResponse>>(this.priorityLevelsUrl, request);
  }

  update(id: number, request: PriorityLevelRequest): Observable<RequirementApiResponse<PriorityLevelResponse>> {
    return this.http.put<RequirementApiResponse<PriorityLevelResponse>>(`${this.priorityLevelsUrl}/${id}`, request);
  }

  delete(id: number): Observable<PriorityLevelActionResponse> {
    return this.http.delete<PriorityLevelActionResponse>(`${this.priorityLevelsUrl}/${id}`);
  }
}
